// extracted by mini-css-extract-plugin
export var printerCard = "_ha-1";
export var printerCardConfigured = "_ha-2";
export var printerCardError = "_ha-3";
export var printerCardsContainer = "_ha-0";
export var printerIcon = "_ha-8";
export var printerIconConfigured = "_ha-5";
export var printerIconContainer = "_ha-4";
export var printerIconError = "_ha-6";
export var printerIconUnconfigured = "_ha-7";
export var workstationsTableCard = "_ha-9";